import React, { useCallback, useEffect, useState } from "react";
import { API_USER_INFO } from "../../Util/URLConstants";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import RoomsInfo from "../../DashBoard/Profile/RoomsInfo";
import {
  clearSubscription,
  fetchSubscriptionStatus,
} from "../../Redux/slices/subscriptionSlice";
import {
  clearSubscriptionTier,
  fetchSubscriptionTierStatus,
} from "../../Redux/slices/subscriptionTierSlice";

function VMRoomRegistrations() {
  const { state } = useLocation();
  const dispatch = useDispatch();

  const [userState, setUserState] = useState(null);
  const [userID] = useState(state?.user_id || null);

  // Keep the JWT from OTP / venue signup. Room APIs need Authorization.
  // Only drop stale Redux subscription state from a previous session.
  useEffect(() => {
    dispatch(clearSubscription());
    dispatch(clearSubscriptionTier());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getUserInfo = useCallback(() => {
    if (!userID) return;

    axios
      .get(API_USER_INFO + "?user_id=" + userID)
      .then((resp) => {
        const respData = resp.data;
        setUserState(respData.user_info);
        dispatch(fetchSubscriptionStatus(userID));
        dispatch(fetchSubscriptionTierStatus(userID));
      })
      .catch((err) => {
        console.error("Error fetching user info:", err);
      });
  }, [dispatch, userID]);

  useEffect(() => {
    getUserInfo();
  }, [getUserInfo]);

  return (
    <div>

              {userState && <RoomsInfo userState={userState} />}
    </div>
  )
}

export default VMRoomRegistrations